'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumBusinessPartner as LogoSupplier } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { useTranslation } from '@/lib/i18n';

// TODO [将来]: PRC Force 専用ロゴが用意されたら差し替える（デザインチーム待ち）

export const Route = createFileRoute('/_staff/supplier/_list')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  const tabs = [{
    to: '/supplier/overview',
    children: t('common.list.overview')
  }, {
    to: '/supplier',
    children: t('pages.supplierLedger.listPageTitle'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/supplier/alerts',
    children: t('common.list.alerts')
  }, {
    to: '/supplier/contract-and-cost',
    children: t('common.list.contractAndCost')
  }, {
    to: '/supplier/operation-activity',
    children: t('common.list.operationActivity')
  }, {
    to: '/supplier/rule-and-policy',
    children: t('common.list.ruleAndPolicy')
  }, {
    to: '/supplier/settings',
    children: t('common.list.settings')
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoSupplier} name={t('common.list.suppliers')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}